/**
 * Created by chenzheyu on 2017/6/16.
 */
import XKUnfilledOrderMod from './src/unfilledOrderMod.vue'

XKUnfilledOrderMod.install = function (Vue) {
  Vue.component(XKUnfilledOrderMod.name, XKUnfilledOrderMod)
}

export default XKUnfilledOrderMod



// WEBPACK FOOTER //
// ./src/components/module/unfilledOrderMod/index.js